import Color from '../Color.mjs'
import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.SKY_BLUE,
    type: 'CAT_MD',
    name: 'MD知识分类',
}
